import React, {useState} from 'react';
import ModalCustom from '../modal/modal';
import styles from './generic-error-modal.module.scss';
import errorIcon from '../../assets/error.svg';

const ErrorContent = () => {
  return (
    <div className={styles['content-wrapper']}>
      <div>
        <img src={errorIcon}/>
      </div>
      <div className={styles['title']}>
        Something went wrong.
      </div>
      <div className={styles['body']}>
        Reservation encountered a problem. Please contact system administrator.
      </div>
    </div>
  )
}

const GenericErrorModal = ({show, setShow}) => {
  return <ModalCustom
    show={show}
    title={"Error"}
    onClose={() => setShow(false)}
    component={<ErrorContent/>}
    style={styles['modal-content']}/>
}

export default GenericErrorModal;



